import { UserType } from '@/@types';
import { Scrollable } from '@/components/core';
import { UIComponent } from '@/components/core/components';
import UserCard from '@/components/core/components/molecules/user-card';
import { Trans } from '@lingui/react/macro';
import * as styles from './users.styles';

const Users: UIComponent<{ users: UserType[] }> = ({ users }) => {
  return (
    <section className={styles.root}>
      <h3 className={styles.title}>
        <Trans>The most relevant users to follow</Trans>
      </h3>
      <Scrollable snap>
        <div className={styles.list}>
          {users.map((user) => {
            return <UserCard key={user.id} user={user} />;
          })}
        </div>
      </Scrollable>
    </section>
  );
};

export default Users;
